import { Model } from '@vuex-orm/core';

export class Country extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'countries';

  static primaryKey = 'code';

  static fields() {
    return {
      code: this.attr(null),
      name: this.attr(null),
      dial_code: this.attr(null),
    };
  }
}

export default Country;
